import React, { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const SolidTriangle = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  return <svg fill="none" viewBox="0 0 16 8" {...props} ref={ref}>
      <path fill="#e05109" stroke="#e05109" d="M14.793 7.5H1.207L8 .707z" />
    </svg>;
});
export default SolidTriangle;